<template>
  <el-tabs v-model="bulletinsType" @tab-click="handleTabChange">
    <el-tab-pane v-if="isTabShow('transfer')" label="变动信息" name="transfer">
      <el-form size="mini" label-width="120px">
        <el-form-item label="*行业" prop="行业">
          <el-select v-model="formData['行业']" filterable style="width:240px">
            <el-option v-for="(hangye, k) in transferHangyes" :key="k" :label="hangye" :value="hangye"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*公司" prop="公司">
          <el-autocomplete
            v-model="formData['公司']"
            :fetch-suggestions="querySearch"
            placeholder="搜索或选择"
            style="width:240px"
            @change="changeTitle"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="*模块" prop="模块">
          <el-select v-model="formData['模块']" multiple filterable placeholder="选择" style="width:240px">
            <el-option v-for="func in cateData" :key="func" :label="func" :value="func"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*变动因素" prop="变动因素">
          <el-select
            v-model="formData['变动因素']"
            filterable
            placeholder="选择"
            style="width:240px"
            @change="changeTitle"
          >
            <el-option v-for="t in transferFuncType" :key="t" :label="t" :value="t"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="formData['变动因素'] == '中高层人员变化'">
          <el-form-item label="变动人员">
            <el-input v-model="formData['变动人员']" placeholder="输入人员姓名" style="width:240px"></el-input>
          </el-form-item>
          <el-form-item label="离职公司" prop="离职公司">
            <el-autocomplete
              v-model="formData['离职公司']"
              :fetch-suggestions="querySearch"
              style="width:240px"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="原公司职位">
            <el-input v-model="formData['原公司职位']" style="width:240px"></el-input>
          </el-form-item>
          <el-form-item label="入职公司" prop="入职公司">
            <el-autocomplete
              v-model="formData['入职公司']"
              :fetch-suggestions="querySearch"
              style="width:240px"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="新公司职位">
            <el-input v-model="formData['新公司职位']" style="width:240px"></el-input>
          </el-form-item>
          <el-form-item label="*离职时间段" prop="离职时间段">
            <el-radio-group v-model="formData.离职时间段">
              <el-radio label="本月">本月</el-radio>
              <el-radio label="三个月前">三个月前</el-radio>
              <el-radio label="半年前">半年前</el-radio>
              <el-radio label="一年前">一年前</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <el-form-item label="*变动影响程度" prop="变动影响程度">
          <el-select v-model="formData['变动影响程度']" filterable placeholder="选择" style="width:240px">
            <el-option v-for="level in transferFuncLevel" :key="level" :label="level" :value="level"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="*标题"> <el-input v-model="formData['标题']"></el-input> </el-form-item>
        <el-form-item label="详情" prop="详情">
          <el-input v-model="formData['详情']" type="textarea" rows="5"></el-input>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <el-tab-pane v-if="isTabShow('bd')" label="招聘信息" name="bd">
      <el-form :model="formData" size="mini" label-width="120px">
        <el-form-item label="*公司" prop="公司">
          <el-autocomplete
            v-model="formData['公司']"
            :fetch-suggestions="querySearch"
            style="width:240px"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="行业" prop="行业">
          <el-select v-model="formData['行业']" filterable style="width:240px">
            <el-option v-for="(hangye, k) in transferHangyes" :key="k" :label="hangye" :value="hangye"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地域" prop="地域">
          <el-select
            v-model="formData['地域']"
            multiple
            filterable
            allow-create
            placeholder="选择或输入后选择"
            style="width:240px"
          >
            <el-option v-for="diyu in diyuData" :key="diyu" :label="diyu" :value="diyu"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模块" prop="模块">
          <el-select v-model="formData['模块']" multiple filterable placeholder="选择" style="width:240px">
            <el-option v-for="func in cateData" :key="func" :label="func" :value="func"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="部门">
          <el-input v-model="formData['部门']" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="岗位类型" prop="岗位类型">
          <el-select v-model="formData['岗位类型']" filterable style="width:240px">
            <el-option v-for="(type, k) in bdType" :key="k" :label="type" :value="type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!formData._id" label="跟进人" prop="跟进人">
          <el-select v-model="formData['跟进人']" filterable style="width:240px">
            <el-option v-for="account in accounts" :key="account" :label="account" :value="account"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇报上级" prop="汇报上级">
          <el-input v-model="formData['汇报上级']" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="*岗位名称" prop="岗位名称">
          <el-input v-model="formData['岗位名称']"></el-input>
        </el-form-item>
        <el-form-item label="*岗位详情" prop="岗位详情">
          <el-input v-model="formData['岗位详情']" type="textarea" rows="5"></el-input>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <el-tab-pane v-if="isTabShow('others')" label="市场新闻" name="others">
      <el-form :model="formData" size="mini" label-width="120px">
        <el-form-item label="标题" prop="标题"> <el-input v-model="formData['标题']"></el-input> </el-form-item>
        <el-form-item label="公司" prop="公司">
          <el-autocomplete
            v-model="formData['公司']"
            :fetch-suggestions="querySearch"
            placeholder="搜索或选择"
            style="width:240px"
            @change="changeTitle"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="内容" prop="内容">
          <el-input v-model="formData['内容']" type="textarea" rows="5"></el-input>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <el-tab-pane v-if="isTabShow('financing')" label="融资信息" name="financing">
      <el-form :model="formData" size="mini" label-width="120px">
        <el-form-item label="标题" prop="标题"> <el-input v-model="formData['标题']"></el-input> </el-form-item>
        <el-form-item label="公司" prop="公司">
          <el-autocomplete
            v-model="formData['公司']"
            :fetch-suggestions="querySearch"
            placeholder="搜索或选择"
            style="width:240px"
            @change="changeTitle"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item label="疑似联系方式" prop="疑似联系方式">
          <el-input v-model="formData['疑似联系方式']" type="textarea" rows="5"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="内容">
          <el-input v-model="formData['内容']" type="textarea" rows="5"></el-input>
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import { diYu } from '../../../radish/src/constant/common-var'

const dateFormat = require('dateformat')

export default {
  props: {
    handleSave: {
      type: Function,
      default: () => {},
    },
    handleUpdate: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      cateData: [],
      diyuData: diYu || [],
      accounts: [],
      formData: {},
      bulletinsType: 'transfer',
      transferHangyes: app.industries || [],
      transferFuncType: [
        '监管因素',
        '股东因素',
        '中高层人员变化',
        '薪酬因素',
        '市场变化',
        '办公地点变化',
        '业务踩雷',
        '公司经营出现问题',
        '裁员',
        '募资到位',
        '募资不到位',
        '其他',
      ],
      transferFuncLevel: [
        '5-导致大批人员离职',
        '4-影响部分人员选择跳槽',
        '3-虽有影响，但人选观望态度',
        '2-公司有相应政策，未产生影响',
        '1-变动是比较好的方向增加人员稳定',
      ],
      bdType: ['5-高端-猎头职位', '4-中端-猎头职位', '3-低端-猎头职位', '2-高端-非猎头职位', '1-中端-非猎头职位'],
    }
  },
  async mounted() {
    if (!app.categories) {
      await app.getCats()
    }
    this.cateData = ['全部'].concat(app.categories.map(cate => cate['名称']))
    Promise.all([this.loadAccount()])
  },
  methods: {
    show: async function(params) {
      const { bulletinsType, formData } = params
      if (bulletinsType) this.bulletinsType = bulletinsType
      const form = formData || {}
      if (!Array.isArray(form.模块)) {
        form.模块 = form.模块 ? form.模块.split(',') : []
      }
      delete form.company
      delete form.跟进信息
      this.formData = form
      if (this.accounts.length === 0) {
        await this.loadAccount()
      }
    },
    isTabShow: function(tab) {
      if (!this.formData._id) {
        return true
      }
      if (tab === this.bulletinsType) {
        return true
      }
      return false
    },
    changeTitle: function() {
      if (this.formData['变动因素'] == '中高层人员变化' && !this.formData['标题']) {
        this.formData = Object.assign({}, this.formData, { 标题: `${this.formData['公司'] || ''}人员变动` })
      } else {
        this.formData = Object.assign({}, this.formData, { 标题: '' })
      }
    },
    handleTabChange: function() {
      this.formData = {}
    },
    loadCompany: async function(queryString) {
      let res
      if (queryString) {
        const query = { 简称: { $regex: queryString, $options: 'i' } }
        if (this.formData['行业']) query.行业 = this.formData['行业']
        res = await app.service('company').getCompanySimpleList({
          query,
          fields: { 简称: 1, 排名: 1 },
          sort: { 排名: 1 },
        })
      } else {
        res = await app.service('project').getDefaultCompanies()
      }
      const list = res.data.map(item => ({
        value: item['简称'],
      }))
      return list
    },
    loadAccount: async function() {
      const res = await app.service('misc').listAccounts()
      // console.log(res)
      if (res.status == 'success') {
        this.accounts = res.data.map(u => u.account)
      }
    },
    querySearch: async function(queryString, cb) {
      const list = await this.loadCompany(queryString)
      return cb(list)
    },
    getLiTime(duan) {
      const d = new Date().getTime()
      let str = ''
      switch (duan) {
        case '本月':
          str = d
          break
        case '三个月前':
          str = d - 3600 * 24 * 91 * 1000
          break
        case '半年前':
          str = d - 3600 * 24 * 182 * 1000
          break
        case '一年前':
          str = d - 3600 * 24 * 365 * 1000
          break
        default:
          str = d
          break
      }
      return dateFormat(str, 'yyyy-mm-dd')
    },
    valiBulletin: function() {
      if (this.bulletinsType === 'transfer') {
        if (!this.formData['行业']) {
          this.$message.info('请填写行业')
          return false
        }
        if (!this.formData['公司']) {
          this.$message.info('请填写公司')
          return false
        }
        if (!this.formData['模块'] || this.formData['模块'].length === 0) {
          this.$message.info('请填写模块')
          return false
        }
        if (!this.formData['变动因素']) {
          this.$message.info('请填写变动因素')
          return false
        }
        if (!this.formData['变动影响程度']) {
          this.$message.info('请填写变动影响程度')
          return false
        }
        if (this.formData['变动因素'] == '中高层人员变化' && !this.formData.离职时间段) {
          this.$message.info('请填写离职时间段')
          return false
        }
      } else if (this.bulletinsType === 'bd') {
        if (!this.formData['公司']) {
          this.$message.info('请填写公司')
          return false
        }
        if (!this.formData['岗位名称']) {
          this.$message.info('请填写岗位名称')
          return false
        }
        if (!this.formData['岗位详情']) {
          this.$message.info('请填写岗位详情')
          return false
        }
      }
      return true
    },
    saveBulletin: async function() {
      if (!this.valiBulletin()) return false
      this.$parent.isSaveShow = false
      const formData = Object.assign({}, this.formData)
      if (this.bulletinsType === 'transfer') {
        if (!formData['标题']) formData['标题'] = `${formData['公司']}变动信息`
        formData['模块'] = formData['模块'] && Array.isArray(formData['模块']) ? formData['模块'].join(',') : ''
        if (formData['变动因素'] == '中高层人员变化')
          formData['离职具体时间'] = this.getLiTime(this.formData.离职时间段)
      } else if (this.bulletinsType === 'bd') {
        formData['标题'] = `${formData['公司']}招聘信息`
        // formData['模块'] = formData['模块'].join(',')
        formData['模块'] = formData['模块'] && Array.isArray(formData['模块']) ? formData['模块'].join(',') : ''
      }
      formData['发布人'] = app.user.account
      formData['时间'] = dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss')
      formData.type = this.bulletinsType
      const res = await app.service('misc').addBulletin(formData)
      // console.log(res);
      if (res.status === 'success') {
        this.$message.success('新建成功')
        formData._id = res.data.id
        this.handleSave(formData)
        this.updateYiyuandu(formData)
        this.formData = {}
      } else {
        this.$message.error(res.msg)
      }
      this.$parent.isSaveShow = true
      return true
    },

    updateBulletin: async function() {
      if (!this.valiBulletin()) return false
      this.$parent.isSaveShow = false
      const formData = Object.assign({}, this.formData)
      formData['发布人'] = app.user.account
      formData['时间'] = dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss')
      formData.type = this.bulletinsType
      if (this.bulletinsType === 'transfer') {
        if (!formData['标题']) formData['标题'] = `${formData['公司']}变动信息`
        formData['模块'] = formData['模块'].join(',')
      } else if (this.bulletinsType === 'bd') {
        formData['标题'] = `${formData['公司']}招聘信息`
        formData['模块'] = formData['模块'].join(',')
      }
      const res = await app.service('misc').modifyBulletin({
        _id: formData._id,
        data: formData,
      })
      if (res.status === 'success') {
        this.$message.success('保存成功')
        this.handleUpdate(formData)
        this.updateYiyuandu(formData)
      } else {
        this.$message.error(res.msg)
      }
      this.$parent.isSaveShow = true
      return true
    },
    updateYiyuandu(formData) {
      if (formData.type === 'transfer' && formData['公司']) {
        const num = parseInt(formData['变动影响程度'].slice(0, 1), 10)
        let percent = 0
        if (num === 5) {
          if (percent < 95) {
            percent = 95
          }
        } else if (num === 4) {
          if (percent < 75) {
            percent = 75
          }
        } else if (num === 3) {
          if (percent < 55) {
            percent = 55
          }
        }
        if (num > 2) {
          app.service('misc').updateYiyuandu({
            company: formData['公司'],
            category: formData['模块'],
            percent,
            time: formData['时间'],
          })
        }
      }
    },
  },
}
</script>
